import React, { Component, useEffect } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

import Body from '../Components/layout/Body';
import OtherTextInput from '../Components/layout/OtherTextInput';
import { PLATFORM_BUTTONS } from './ConstPlatformBtns';
import { OTHER_CKBX_VAL, isOtherChecked } from './OtherCheckboxUtils';

const PLATFORMS_HELP = `
  <div>
    <p><strong>Purpose:</strong> If a client has experience with specific computing devices, you may want to leverage that experience in your assessment.  
    If you can include a familiar device in the assessment, that will be one less new thing that the client has to deal with.  
    If you can’t, just keep in mind that using an unfamiliar device may make the tasks a little slower and more difficult. 
    </p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  platformsUsed: PropTypes.arrayOf(PropTypes.string),
  onChangePlatformsUsed: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  platforms: []
};

//content sub-component with unique content for this page
class HistoryPlatformsContent extends Component {
  constructor(props){
    super(props);
    this.validate = this.validate.bind(this);
  }

  validate(){
  }

  //Render the form for the main goal.
  //Calls the setter that's passed in by the parent, when a checkbox is clicked.
  //That setter changes the state of the mainGoal in the parent, 
  //which triggers a new render of the view with the new goal.

  //TODO: group these into categories, e.g., to leave a blank line between types of devices as in the wireframe
  render(){
    const platformsUsed = this.props.platformsUsed ?? [];
    const onChangePlatformsUsed= this.props.onChangePlatformsUsed;
    console.log("rendering GatherInfoHistoryPlatforms with platforms: " + platformsUsed);
    const otherPlatformUsed = this.props.otherPlatformUsed;
    const onChangeOtherPlatformUsed = this.props.onChangeOtherPlatformUsed;

    let activeBtns = PLATFORM_BUTTONS; 
    let otherChecked = isOtherChecked(platformsUsed);

    return(
    <>
    <Form>
      <FormGroup tag="fieldset">
        <legend>Check all that apply:</legend>
        {activeBtns.map((btn, index) =>
          <React.Fragment key={index}>
          <FormGroup check key={index}>
            <Input
              id={btn.value}
              value={btn.value}
              checked={platformsUsed.findIndex( (plat) => plat.startsWith(btn.value)) > -1}
              onChange={onChangePlatformsUsed} 
              name="platforms"
              type="checkbox"
            />
            {' '}
            <Label for={btn.value} check>
              {btn.label}
              {' '}
              <span className="aa-more-info">{btn.moreInfo}</span>
            </Label>
          </FormGroup>
          {/* If the btn is 'other', include a text field to specify */}
          { ((btn.value === OTHER_CKBX_VAL)) 
            ?
            <OtherTextInput
              otherChecked={otherChecked}
              otherText={otherPlatformUsed}
              onChangeOtherText={onChangeOtherPlatformUsed}
            />
          : null
          }
          </React.Fragment>
        )}
      </FormGroup>
    </Form>
    </>
    );
  }
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component.
//since the main goal step includes a form, receive the initial form values via props,
//along with setters to change those values based on the form input.
function GatherInfoHistoryPlatforms(props) {
  const firstName = props.firstName;
  const platformsUsed = props.platformsUsed;
  const onChangePlatformsUsed = props.onChangePlatformsUsed;
  const otherPlatformUsed = props.otherPlatformUsed;
  const onChangeOtherPlatformUsed = props.onChangeOtherPlatformUsed;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;

  console.log("rendering GatherInfoHistoryPlatforms, platforms: " + platformsUsed);

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-clock-o",
    pageSymbolClassName: "aa-section-symbol gather",

    title: `What computing devices has ${firstName} used before?`,
    subTitle: `If ${firstName} is already familiar with using specific types of computing devices, mark those here.`,
    learnMore: {linkText: "Learn More about device platforms and whether this matters to you",
                title: "Device Platforms",
                content: PLATFORMS_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true
  }

  useEffect(() => {
    console.log('GIHPlatforms mounted');
    return () => {
      console.log('GIHPlatforms unmounting and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <HistoryPlatformsContent 
          platformsUsed={platformsUsed} 
          onChangePlatformsUsed={onChangePlatformsUsed}
          otherPlatformUsed={otherPlatformUsed}
          onChangeOtherPlatformUsed={onChangeOtherPlatformUsed}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoHistoryPlatforms.propTypes = propTypes;
GatherInfoHistoryPlatforms.defaultProps = defaultProps;

export default GatherInfoHistoryPlatforms;